import { IFile } from "../domain/models/File";
import { IPartnersFlat } from "../domain/models/Partners";
import { BaseModelImpl } from "./BaseModelImpl";

export class PartnersFlatModel
    extends BaseModelImpl<IPartnersFlat>
    implements IPartnersFlat
{
    id: string;
    files?: IFile[];

    isActive: boolean;
    languageCode: string;

    title: string;
    description?: string;
    websiteUrl?: string;

    updatorId?: string;
    creatorId?: string;
    createdAt?: Date;
    updatedAt?: Date;

    constructor(data?: IPartnersFlat) {
        super();
        this.assignData(data);
    }
}
